(() => {
  const $ = (sel, root = document) => root.querySelector(sel);

  const overlay = () => document.getElementById('ccd-overlay');
  const drawer = () => document.getElementById('ccd-drawer');
  const bodyEl = () => document.getElementById('ccd-body');
  const subtotalEl = () => document.getElementById('ccd-subtotal');

  const discountRowEl = () => document.getElementById('ccd-discount-row');
  const discountEl = () => document.getElementById('ccd-discount');
  const discountLabelEl = () =>
    document.querySelector('#ccd-discount-row .ccd-row-label');

  // ✅ We'll inject this into the footer (above DISCOUNT) via JS so you don't need Liquid yet
  const ensureUpsellEl = () => {
    const dRow = discountRowEl();
    if (!dRow) return null;

    // try existing
    let el = document.getElementById('ccd-discount-upsell');
    if (el) return el;

    // create + insert above discount row
    el = document.createElement('div');
    el.id = 'ccd-discount-upsell';
    el.className = 'ccd-discount-upsell';
    el.hidden = true;

    // insert before discount row inside same parent
    const parent = dRow.parentElement;
    if (parent) parent.insertBefore(el, dRow);

    return el;
  };

  // =========================
  // CONFIG (EUR + SEK only)
  // =========================
  const FREE_SHIPPING_THRESHOLDS = () => {
    const injected = window.ccdConfig?.freeShippingThresholds || {};
    return {
      EUR: Number(injected.EUR ?? 3900),
      SEK: Number(injected.SEK ?? 39900),
    };
  };

  const CCD_I18N_FALLBACK = {
    en: {
      empty: 'Your cart is empty',
      free_ship_locked: 'SPEND {{amount}} AND GET FREE SHIPPING!',
      free_ship_unlocked: 'FREE SHIPPING UNLOCKED!',
      // ✅ discount upsell
      discount_upsell_1: 'ADD 1 ITEM FOR 20% OFF — OR 2 ITEMS FOR 30% OFF.',
      discount_upsell_2: 'ADD 1 ITEM FOR 30% OFF.',
    },
    sv: {
      empty: 'Din varukorg är tom',
      free_ship_locked: 'HANDLA FÖR {{amount}} TILL OCH FÅ FRI FRAKT!',
      free_ship_unlocked: 'FRI FRAKT UPPLÅST!',
      // ✅ discount upsell (your Swedish edit)
      discount_upsell_1: 'LÄGG TILL 1 VARA FÖR 20% RABATT — ELLER 2 VAROR FÖR 30% RABATT.',
      discount_upsell_2: 'LÄGG TILL 1 VARA FÖR 30% RABATT.',
    },
    de: {
      empty: 'Dein Warenkorb ist leer',
      free_ship_locked: 'GIB {{amount}} AUS UND ERHALTE KOSTENLOSEN VERSAND!',
      free_ship_unlocked: 'KOSTENLOSER VERSAND FREIGESCHALTET!',
      // ✅ German (keep it short; you can tweak anytime)
      discount_upsell_1: 'FÜGE 1 ARTIKEL FÜR 20% RABATT — ODER 2 FÜR 30%.',
      discount_upsell_2: 'FÜGE 1 ARTIKEL FÜR 30% RABATT.',
    },
  };

  const getLocale = () => {
    const raw =
      window.Shopify?.locale ||
      document.documentElement.getAttribute('lang') ||
      'en';
    return String(raw).toLowerCase().split('-')[0];
  };

  const t = (key, vars = {}) => {
    const loc = getLocale();
    const fromInjected =
      window.ccdI18n && typeof window.ccdI18n[key] === 'string'
        ? window.ccdI18n[key]
        : null;

    const fromFallback =
      CCD_I18N_FALLBACK[loc] && CCD_I18N_FALLBACK[loc][key]
        ? CCD_I18N_FALLBACK[loc][key]
        : CCD_I18N_FALLBACK.en[key] || '';

    let str = fromInjected || fromFallback;
    Object.keys(vars).forEach((k) => {
      str = str.replaceAll(`{{${k}}}`, String(vars[k]));
    });
    return str;
  };

  const getActiveCurrency = (cart) => {
    return cart?.currency || window.Shopify?.currency?.active || 'EUR';
  };

  const getFreeShippingThreshold = (currencyCode) => {
    const code = String(currencyCode || 'EUR').toUpperCase();
    const map = FREE_SHIPPING_THRESHOLDS();
    return Number(map[code] ?? map.EUR);
  };

  // =========================
  // SAFE FIX: menu overlay stuck (aria-expanded true)
  // =========================
  const getMenuDetails = () => {
    return (
      document.querySelector('header-drawer details') ||
      document.querySelector('details[id^="Details-menu-drawer-container"]') ||
      document.querySelector('details[id*="menu-drawer"]') ||
      null
    );
  };

  const getMenuSummary = () => {
    return (
      document.querySelector('header-drawer summary.header__icon--menu') ||
      document.querySelector('summary.header__icon--menu') ||
      document.querySelector('summary[aria-controls="menu-drawer"]') ||
      null
    );
  };

  const fixStuckMenuOverlay = () => {
    const details = getMenuDetails();
    const summary = getMenuSummary();
    if (!summary) return;

    const open = details ? details.hasAttribute('open') : false;

    // If the drawer isn't open, aria-expanded must be false (otherwise Dawn draws overlay ::before)
    if (!open && summary.getAttribute('aria-expanded') === 'true') {
      summary.setAttribute('aria-expanded', 'false');
    }

    // Also release body scroll locks if menu isn't open
    if (!open) {
      document.body.classList.remove(
        'overflow-hidden',
        'overflow-hidden-mobile',
        'overflow-hidden-tablet',
        'overflow-hidden-desktop'
      );
    }
  };

  // =========================
  // INLINE ICON SWAP
  // =========================
  const ensureCCDInlineStyles = () => {
    let style = document.getElementById('ccd-inline-styles');

    const findDawnCloseSvg = () => {
      const candidates = [
        'header .icon-close',
        'sticky-header .icon-close',
        '#menu-drawer .icon-close',
        'details[open] .icon-close',
        'summary[aria-controls="menu-drawer"] .icon-close',
        '[aria-controls="menu-drawer"] .icon-close',
      ];
      for (const sel of candidates) {
        const svg = document.querySelector(sel);
        if (svg && svg.tagName && svg.tagName.toLowerCase() === 'svg') return svg;
      }
      return null;
    };

    const svgToDataUrl = (svgEl) => {
      const clone = svgEl.cloneNode(true);
      clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      clone.removeAttribute('class');
      clone.removeAttribute('style');

      clone.querySelectorAll('*').forEach((node) => {
        if (node.getAttribute('stroke')) node.setAttribute('stroke', 'black');
        if (node.getAttribute('fill')) node.setAttribute('fill', 'black');
        if (!node.getAttribute('fill') && !node.getAttribute('stroke'))
          node.setAttribute('fill', 'black');
      });

      const markup = clone.outerHTML;
      return `data:image/svg+xml,${encodeURIComponent(markup)}`;
    };

    const dawnSvg = findDawnCloseSvg();
    const maskUrl = dawnSvg ? svgToDataUrl(dawnSvg) : null;

    if (!style) {
      style = document.createElement('style');
      style.id = 'ccd-inline-styles';
      document.head.appendChild(style);
    }

    style.textContent = `
      body.ccd-open #cart-icon-bubble .cart-count-bubble{ display:none !important; }
      body.ccd-open #cart-icon-bubble{ position: relative; }
      body.ccd-open #cart-icon-bubble svg{ opacity: 0 !important; }

      body.ccd-open #cart-icon-bubble::after{
        content: "";
        position: absolute;
        inset: 0;
        margin: auto;
        width: 20px;
        height: 20px;
        background: currentColor;
        ${maskUrl ? `
        -webkit-mask: url("${maskUrl}") no-repeat center / contain;
        mask: url("${maskUrl}") no-repeat center / contain;
        ` : `
        -webkit-mask: none;
        mask: none;
        `}
        pointer-events: none;
        transform: translateY(-1px);
      }

      .ccd-close-icon{
        background: currentColor;
        ${maskUrl ? `
        -webkit-mask: url("${maskUrl}") no-repeat center / contain;
        mask: url("${maskUrl}") no-repeat center / contain;
        ` : `
        -webkit-mask: none;
        mask: none;
        `}
      }

      /* ✅ default styling for the upsell text (so JS-only change still looks good) */
      .ccd-discount-upsell{
        font-size: 13px;
        color: #6b6b6b;
        margin-bottom: 6px;
        line-height: 1.3;
      }
    `;
  };

  const money = (cents) => {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        const fmt =
          window.theme?.moneyFormat ||
          window.money_format ||
          window.Shopify?.money_format ||
          '${{amount}}';
        return Shopify.formatMoney(cents, fmt);
      }

      const cur = window.Shopify?.currency?.active
        ? window.Shopify.currency.active
        : undefined;

      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: cur,
      });
    } catch {
      return `${(cents / 100).toFixed(2)}`;
    }
  };

  const setHeaderVar = () => {
    const sticky = $('sticky-header');
    const header = sticky || $('header.header') || $('.shopify-section-group-header-group');
    const h = header ? Math.ceil(header.getBoundingClientRect().height || 0) : 0;
    document.documentElement.style.setProperty('--ccd-header-h', `${h}px`);
  };

  const killDawnCartUI = () => {
    const cn = $('cart-notification') || $('#cart-notification') || $('#CartNotification');
    if (cn) {
      cn.setAttribute('hidden', 'hidden');
      cn.style.display = 'none';
      cn.classList.remove('active', 'is-active');
      cn.removeAttribute('open');
    }

    const cd = $('cart-drawer') || $('#CartDrawer') || $('#cart-drawer');
    if (cd) {
      cd.setAttribute('hidden', 'hidden');
      cd.style.display = 'none';
      cd.classList.remove('active', 'is-active');
      cd.removeAttribute('open');
    }

    document.body.classList.remove('cart-notification-active', 'overflow-hidden');
  };

  // =========================
  // CCD: FORCE HEADER WHITE
  // =========================
  const ccdHeaderState = { el: null, hadGradient: false };

  const getHeaderElForWhite = () => {
    return (
      document.querySelector('sticky-header .header-wrapper') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('sticky-header') ||
      document.querySelector('header.header') ||
      null
    );
  };

  const forceHeaderWhiteOn = () => {
    const el = getHeaderElForWhite();
    if (!el) return;

    ccdHeaderState.el = el;
    ccdHeaderState.hadGradient = el.classList.contains('gradient');

    el.classList.remove('gradient');
    el.style.background = '#fff';
    el.style.backgroundColor = '#fff';
    el.style.backgroundImage = 'none';
  };

  const forceHeaderWhiteOff = () => {
    const el = ccdHeaderState.el;
    if (!el) return;

    el.style.background = '';
    el.style.backgroundColor = '';
    el.style.backgroundImage = '';

    if (ccdHeaderState.hadGradient) el.classList.add('gradient');

    ccdHeaderState.el = null;
    ccdHeaderState.hadGradient = false;
  };

  // =========================
  // MENU <-> CART MUTUAL EXCLUSION
  // =========================
  const closeDawnMenuDrawer = () => {
    document.querySelectorAll('header-drawer details[open]').forEach((d) => {
      d.classList.remove('menu-opening');
      d.removeAttribute('open');
    });

    document.querySelectorAll('details[open]').forEach((d) => {
      if (
        (d.id || '').includes('menu-drawer') ||
        d.querySelector('summary[aria-controls="menu-drawer"]') ||
        d.closest('header-drawer')
      ) {
        d.classList.remove('menu-opening');
        d.removeAttribute('open');
      }
    });

    requestAnimationFrame(() => fixStuckMenuOverlay());
    setTimeout(() => fixStuckMenuOverlay(), 50);

    document.body.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop'
    );
  };

  const isMenuDrawerDetails = (detailsEl) => {
    if (!detailsEl || detailsEl.tagName?.toLowerCase() !== 'details') return false;
    if ((detailsEl.id || '').includes('menu-drawer')) return true;
    if (detailsEl.closest('header-drawer')) return true;
    if (detailsEl.querySelector('summary[aria-controls="menu-drawer"]')) return true;
    return false;
  };

  const bindMenuOpensClosesCCD = () => {
    document.addEventListener(
      'toggle',
      (e) => {
        const d = e.target;
        if (!isMenuDrawerDetails(d)) return;

        if (d.hasAttribute('open') && document.body.classList.contains('ccd-open')) {
          close();
        }

        requestAnimationFrame(() => fixStuckMenuOverlay());
        setTimeout(() => fixStuckMenuOverlay(), 50);
      },
      true
    );
  };

  // =========================
  // ✅ Desktop-only close button (same Dawn icon)
  // =========================
  const ensureCloseButton = () => {
    const panel = document.querySelector('#ccd-drawer .ccd-panel');
    if (!panel) return;

    if (panel.querySelector('.ccd-close-btn')) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ccd-close-btn';
    btn.setAttribute('data-ccd-close', '');
    btn.setAttribute('aria-label', 'Close');
    btn.innerHTML = `<span class="ccd-close-icon" aria-hidden="true"></span>`;
    panel.appendChild(btn);
  };

  // =========================
  // CCD open / close
  // =========================
  const open = async () => {
    const d = drawer();
    const o = overlay();
    if (!d || !o) return false;

    closeDawnMenuDrawer();

    ensureCCDInlineStyles();
    document.body.classList.add('ccd-open');
    forceHeaderWhiteOn();

    await new Promise((r) => requestAnimationFrame(r));
    await new Promise((r) => requestAnimationFrame(r));
    setHeaderVar();

    killDawnCartUI();

    d.hidden = false;
    o.hidden = false;
    d.setAttribute('aria-hidden', 'false');

    ensureCloseButton();

    const b = bodyEl();
    if (b) b.scrollTop = 0;

    return true;
  };

  const close = () => {
    const d = drawer();
    const o = overlay();
    if (!d || !o) return;

    d.setAttribute('aria-hidden', 'true');
    d.hidden = true;
    o.hidden = true;

    document.documentElement.style.setProperty('--ccd-header-h', `0px`);
    forceHeaderWhiteOff();
    document.body.classList.remove('ccd-open');

    requestAnimationFrame(() => fixStuckMenuOverlay());
    setTimeout(() => fixStuckMenuOverlay(), 50);
  };

  // =========================
  // Cart API helpers
  // =========================
  const fetchCart = async () => {
    const url = `${window.routes?.cart_url || '/cart'}.js`;
    const res = await fetch(url, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    return res.json();
  };

  const changeLine = async (line, quantity) => {
    const url = `${window.routes?.cart_change_url || '/cart/change'}.js`;
    await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line, quantity }),
    });
  };

  const escapeHtml = (str) =>
    String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  const updateHeaderBubble = (count) => {
    const bubble = $('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    if (bubble) bubble.textContent = String(count || 0);
  };

  // Free shipping block
  const shipBlockHtml = () => `
    <div class="ccd-ship" id="ccd-ship">
      <p class="ccd-ship__text" id="ccd-ship-text"></p>
      <div
        class="ccd-ship__bar"
        id="ccd-ship-bar"
        aria-hidden="true"
        style="
          --ccd-pct:0%;
          display:block;
          width:100%;
          height:8px;
          border-radius:999px;
          overflow:hidden;
          background: linear-gradient(#111 0 0) 0 0 / var(--ccd-pct, 0%) 100% no-repeat, #e6e6e6;
        "
      ></div>
    </div>
  `;

  const updateFreeShippingUI = (priceTotal, cart) => {
    const root = bodyEl();
    if (!root) return;

    const bar = root.querySelector('#ccd-ship-bar');
    const text = root.querySelector('#ccd-ship-text');
    if (!bar || !text) return;

    const currency = getActiveCurrency(cart);
    const threshold = Math.max(1, getFreeShippingThreshold(currency));

    const pctRaw = (priceTotal / threshold) * 100;
    const pct = Math.max(0, Math.min(100, pctRaw));

    bar.style.setProperty('--ccd-pct', `${pct}%`);
    bar.style.background = `linear-gradient(#111 0 0) 0 0 / ${pct}% 100% no-repeat, #e6e6e6`;

    // ✅ ONLY free shipping message here (upsell moved to footer)
    if (priceTotal >= threshold) {
      text.textContent = t('free_ship_unlocked');
    } else {
      const remaining = threshold - priceTotal;
      text.textContent = t('free_ship_locked', { amount: money(remaining) });
    }
  };

  const render = (cart) => {
    const b = bodyEl();
    const s = subtotalEl();
    const dRow = discountRowEl();
    const dVal = discountEl();
    const dLabel = discountLabelEl();
    const upsellEl = ensureUpsellEl();

    if (!b || !s) return;

    if (!cart.items || cart.items.length === 0) {
      b.innerHTML = `<div class="ccd-empty">${escapeHtml(t('empty'))}</div>`;
      s.textContent = money(0);

      if (upsellEl) {
        upsellEl.hidden = true;
        upsellEl.textContent = '';
      }

      if (dRow) dRow.hidden = true;
      if (dVal) dVal.textContent = '—';
      if (dLabel) dLabel.textContent = 'DISCOUNT';
      updateHeaderBubble(0);
      ensureCloseButton();
      return;
    }

    const itemsHtml = cart.items
      .map((item, idx) => {
        const line = idx + 1;

        const img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2') : '';
        const title = item.product_title || item.title || '';
        const variant =
          item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        const qty = item.quantity;

        // ✅ Use Shopify's actual discounted pricing (automatic discounts / discount codes)
        const unitFinal = typeof item.final_price === 'number' ? item.final_price : 0;
        const unitOriginal = typeof item.original_price === 'number' ? item.original_price : unitFinal;
        const hasDiscount = unitOriginal > unitFinal;

        const priceHtml = hasDiscount
          ? `
              <div class="ccd-item-price-stack">
                <div class="ccd-price-compare">${money(unitOriginal)}</div>
                <div class="ccd-price-final">${money(unitFinal)}</div>
              </div>
            `
          : `
              <div class="ccd-item-price-stack">
                <div class="ccd-price-final ccd-price-final--nosale">${money(unitFinal)}</div>
              </div>
            `;

        return `
          <div class="ccd-item" data-line="${line}">
            <div class="ccd-item-img">
              ${img ? `<img src="${img}" alt="${escapeHtml(title)}" loading="lazy">` : ``}
            </div>

            <div class="ccd-item-main">
              <div class="ccd-item-title">
                <a class="ccd-item-title-link" href="${item.url || '#'}">${escapeHtml(title)}</a>
              </div>
              ${variant ? `<div class="ccd-item-variant">${escapeHtml(variant)}</div>` : ``}

              <div class="ccd-qty">
                <button class="ccd-qty-btn" type="button" data-ccd-minus aria-label="Minus">−</button>
                <span class="ccd-qty-val" aria-label="Quantity">${qty}</span>
                <button class="ccd-qty-btn" type="button" data-ccd-plus aria-label="Plus">+</button>
                <button class="ccd-remove" type="button" data-ccd-remove aria-label="Remove">🗑</button>
              </div>
            </div>

            <div class="ccd-item-price">${priceHtml}</div>
          </div>
        `;
      })
      .join('');

    b.innerHTML = shipBlockHtml() + itemsHtml;

    // ✅ Totals from Shopify (reflects automatic discounts / discount codes)
    const totalPayable = typeof cart.total_price === 'number' ? cart.total_price : 0;
    const totalDiscount = typeof cart.total_discount === 'number' ? cart.total_discount : 0;

    // Free shipping progress should reflect what customer actually pays
    updateFreeShippingUI(totalPayable, cart);

    // Subtotal should be what customer will pay
    s.textContent = money(totalPayable);

    // =========================
    // ✅ Upsell logic moved to footer (above DISCOUNT)
    // =========================
    if (upsellEl) {
      if (cart.item_count === 1) {
        upsellEl.textContent = t('discount_upsell_1');
        upsellEl.hidden = false;
      } else if (cart.item_count === 2) {
        upsellEl.textContent = t('discount_upsell_2');
        upsellEl.hidden = false;
      } else {
        upsellEl.hidden = true; // 3+ items → hide completely
        upsellEl.textContent = '';
      }
    }

    // Discount row should reflect Shopify discounts
    if (dRow && dVal) {
      if (totalDiscount > 0) {
        dRow.hidden = false;

        // ✅ Label shows tier on LEFT side: "DISCOUNT (-20%)" / "DISCOUNT (-30%)"
        let pctLabel = '';
        if (cart.item_count >= 3) pctLabel = ' (-30%)';
        else if (cart.item_count >= 2) pctLabel = ' (-20%)';

        if (dLabel) dLabel.textContent = `DISCOUNT${pctLabel}`;

        // ✅ Amount on RIGHT side stays just the value
        dVal.textContent = `-${money(totalDiscount)}`;
      } else {
        dRow.hidden = true;
        dVal.textContent = '—';
        if (dLabel) dLabel.textContent = 'DISCOUNT';
      }
    }

    updateHeaderBubble(cart.item_count);
    ensureCloseButton();
  };

  const refresh = async () => {
    const cart = await fetchCart();
    render(cart);
    killDawnCartUI();
    return cart;
  };

  // If user taps hamburger menu while CCD open -> close CCD and allow menu to open
  let ccdReopenMenuOnce = false;
  const bindMenuToggleFix = () => {
    document.addEventListener(
      'click',
      (e) => {
        if (ccdReopenMenuOnce && e.isTrusted === false) {
          ccdReopenMenuOnce = false;
          return;
        }

        if (!document.body.classList.contains('ccd-open')) return;

        const menuTrigger =
          e.target.closest('summary.header__icon--menu') ||
          e.target.closest('button.header__icon--menu') ||
          e.target.closest('[aria-controls="menu-drawer"]') ||
          e.target.closest('summary[aria-controls="menu-drawer"]') ||
          e.target.closest('button[aria-controls="menu-drawer"]');

        if (!menuTrigger) return;

        close();
        ccdReopenMenuOnce = true;
        setTimeout(() => (ccdReopenMenuOnce = false), 0);
      },
      true
    );
  };

  const bindCartIcon = () => {
    document.addEventListener(
      'click',
      async (e) => {
        const cartEl = e.target.closest('#cart-icon-bubble');
        if (!cartEl) return;

        if (!drawer() || !overlay()) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

        closeDawnMenuDrawer();

        if (document.body.classList.contains('ccd-open')) {
          close();
          return;
        }

        await refresh();
        await open();
      },
      true
    );
  };

  const bindClose = () => {
    document.addEventListener(
      'click',
      (e) => {
        if (e.target.closest('[data-ccd-close]')) {
          close();
          return;
        }

        if (
          document.body.classList.contains('ccd-open') &&
          window.matchMedia('(min-width: 750px)').matches
        ) {
          const panel = document.querySelector('#ccd-drawer .ccd-panel');
          if (panel && !panel.contains(e.target)) {
            close();
            return;
          }
        }

        if (e.target.id === 'ccd-overlay') {
          close();
        }
      },
      true
    );

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  };

  const bindQty = () => {
    document.addEventListener('click', async (e) => {
      const item = e.target.closest('.ccd-item');
      if (!item) return;

      const line = Number(item.dataset.line);
      if (!line) return;

      if (e.target.closest('[data-ccd-plus]')) {
        const current = Number(item.querySelector('.ccd-qty-val')?.textContent || 1);
        await changeLine(line, current + 1);
        await refresh();
        return;
      }

      if (e.target.closest('[data-ccd-minus]')) {
        const current = Number(item.querySelector('.ccd-qty-val')?.textContent || 1);
        const next = Math.max(0, current - 1);
        await changeLine(line, next);
        await refresh();
        return;
      }

      if (e.target.closest('[data-ccd-remove]')) {
        await changeLine(line, 0);
        await refresh();
      }
    });
  };

  const init = () => {
    ensureCCDInlineStyles();
    killDawnCartUI();
    ensureCloseButton();

    // ✅ ensure upsell element exists even before first render
    ensureUpsellEl();

    requestAnimationFrame(() => fixStuckMenuOverlay());
    setTimeout(() => fixStuckMenuOverlay(), 100);

    bindMenuToggleFix();
    bindMenuOpensClosesCCD();
    bindCartIcon();
    bindClose();
    bindQty();

    // Auto-open CCD after any /cart/add request (your original behavior)
    if (!window.__ccdFetchPatched) {
      window.__ccdFetchPatched = true;
      const origFetch = window.fetch.bind(window);

      window.fetch = async (...args) => {
        const res = await origFetch(...args);

        try {
          const url =
            typeof args[0] === 'string'
              ? args[0]
              : (args[0] && args[0].url)
              ? args[0].url
              : '';

          if (url && url.includes('/cart/add')) {
            setTimeout(async () => {
              closeDawnMenuDrawer();
              await refresh();
              await open();
            }, 0);
          }
        } catch {}

        return res;
      };
    }

    window.addEventListener('resize', () => {
      if (document.body.classList.contains('ccd-open')) {
        requestAnimationFrame(() => setHeaderVar());
      }
      requestAnimationFrame(() => fixStuckMenuOverlay());
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
